import { AppState, AppStateState } from '@/store/state/AppState';

export const appMutations = {
  setAppState(state: AppState, payload: AppStateState) {
    state.state = payload;
  },
};
